import React from 'react';

import VerticalCenter from '../../../elements/VerticalCenter';
import liveVotingCommonScreen from '../common/LiveVotingScreenHOC';

class VotingFinished extends React.Component {
    render() {
        let {i18n} = this.props;
        return (
            <div
                className="fill-container"
                style={{
                    backgroundImage: 'url('+this.props.resPath+'img/live_vote_lock.png)',
                    backgroundSize: 'cover',
                }}>
                <VerticalCenter>
                    <div className="content text-center well">
                        <h2>{i18n['livevoting.title-session-close']}</h2>
                        <hr />
                        <h3>{i18n['livevoting.desc-session-close']}</h3>
                    </div>
                </VerticalCenter>
            </div>
        );
    }
}

export default liveVotingCommonScreen(VotingFinished);
